export const API_PREFIX = '/api';

export const Endpoints = {
  auth: {
    me: `${API_PREFIX}/auth`,
    login: `${API_PREFIX}/auth`,
    logout: `${API_PREFIX}/auth`,
    resetPassword: `${API_PREFIX}/resetpwd`,
    resetPasswordConfirm: `${API_PREFIX}/resetpwd`,
  },

  adminDashboard: {
    summary: `${API_PREFIX}/admin`,
  },

  notifications: {
    list: `${API_PREFIX}/projects`,
    adminList: `${API_PREFIX}/admin/projects`,
  },

  notificationPreferences: {
    currentUser: `${API_PREFIX}/notification_preferences`,
    eventTypes: `${API_PREFIX}/notification_preferences/event_types`,
  },

  datasheets: {
    upload: `${API_PREFIX}/datasheets`,
    adminUpload: `${API_PREFIX}/admin/datasheets`,
    one: (id: string) => `${API_PREFIX}/datasheets/${id}`,
    adminOne: (id: string) => `${API_PREFIX}/admin/datasheets/${id}`,
  },

  partNumberAvailability: {
    check: '/api/part_numbers/availability',
  },

  events: {
    list: '/api/events',
    adminList: '/api/admin/events',
    one: (eventId: string) => `/api/events/${eventId}`,
    adminOne: (eventId: string) => `/api/admin/events/${eventId}`,
    adminResellers: '/api/admin/events/resellers',
  },

  users: {
    list: '/api/users',
    adminList: '/api/admin/users',
    self: '/api/users/me',
    adminExport: '/api/admin/users/export',
    one: (userId: string) => `/api/users/${userId}`,
    adminOne: (userId: string) => `/api/admin/users/${userId}`,
    bulkDelete: '/api/users/delete',
    adminBulkDelete: '/api/admin/users/delete',
  },

  projects: {
    list: '/api/projects',
    adminList: '/api/admin/projects',
    adminProductionList: '/api/admin/projects/production',
    adminExport: '/api/admin/projects/export',
    one: (projectId: string) => `/api/projects/${projectId}`,
    adminOne: (projectId: string) => `/api/admin/projects/${projectId}`,
    submitPo: (projectId: string) => `/api/projects/${projectId}/po`,
    adminSubmitPo: (projectId: string) => `/api/admin/projects/${projectId}/po`,
    cableRequirements: (projectId: string) => `/api/projects/${projectId}/cable-requirements`,
    adminCableRequirements: (projectId: string) => `/api/admin/projects/${projectId}/cable-requirements`,
    adminBom: (projectId: string) => `/api/admin/projects/${projectId}/bom`,
    adminBomCsv: (projectId: string) => `/api/admin/projects/${projectId}/bom-csv`,
    adminBomBulk: '/api/admin/projects/bom-bulk',
    adminApproveSales: (projectId: string) => `/api/admin/projects/${projectId}/approve-sales`,
    adminApproveSupport: (projectId: string) => `/api/admin/projects/${projectId}/approve-support`,
    adminRejectPo: (projectId: string) => `/api/admin/projects/${projectId}/reject-po`,
    adminPoFile: (projectId: string) => `/api/admin/projects/${projectId}/po/file`,
    adminHistory: (projectId: string) => `/api/admin/projects/${projectId}/history`,
    adminMarkInProduction: (projectId: string) => `/api/admin/projects/${projectId}/mark-in-production`,
    adminMarkShipping: (projectId: string) => `/api/admin/projects/${projectId}/mark-shipping`,
    adminMarkDelivered: (projectId: string) => `/api/admin/projects/${projectId}/mark-delivered`,
    installationSchedule: (projectId: string) => `/api/projects/${projectId}/installation-schedule`,
    adminInstallationSchedule: (projectId: string) => `/api/admin/projects/${projectId}/installation-schedule`,
    adminMarkInstallation: (projectId: string) => `/api/admin/projects/${projectId}/mark-installation`,
    adminMarkCompleted: (projectId: string) => `/api/admin/projects/${projectId}/mark-completed`,
    tracking: (projectId: string) => `/api/projects/${projectId}/tracking`,
    adminTracking: (projectId: string) => `/api/admin/projects/${projectId}/tracking`,
    trackingRefresh: (projectId: string) => `/api/projects/${projectId}/tracking/refresh`,
    adminTrackingRefresh: (projectId: string) => `/api/admin/projects/${projectId}/tracking/refresh`,
    cabinet: (projectId: string, cabinetId: string) => `/api/projects/${projectId}/cabinets/${cabinetId}`,
    adminCabinet: (projectId: string, cabinetId: string) => `/api/admin/projects/${projectId}/cabinets/${cabinetId}`,
    cabinets: (projectId: string) => `/api/projects/${projectId}/cabinets`,
    adminCabinets: (projectId: string) => `/api/admin/projects/${projectId}/cabinets`,
    installationConfig: (projectId: string) => `/api/projects/${projectId}/installation_config`,
    adminInstallationConfig: (projectId: string) => `/api/admin/projects/${projectId}/installation_config`,
    bulkDelete: '/api/projects/delete',
    adminBulkDelete: '/api/admin/projects/delete',
    exportOne: (projectId: string) => `/api/projects/export/${projectId}`,
    adminExportOne: (projectId: string) => `/api/admin/projects/export/${projectId}`,
    archived: '/api/projects/archived',
    adminArchived: '/api/admin/projects/archived',
    tags: (projectId: string) => `/api/projects/${projectId}/tags`,
    adminTags: (projectId: string) => `/api/admin/projects/${projectId}/tags`,
    archiveOne: (projectId: string) => `/api/projects/${projectId}/archived`,
    adminArchiveOne: (projectId: string) => `/api/admin/projects/${projectId}/archived`,
    roomsAndTablets: (projectId: string) => `/api/projects/${projectId}/rooms_and_tablets`,
    adminRoomsAndTablets: (projectId: string) => `/api/admin/projects/${projectId}/rooms_and_tablets`,
    quotePreview: (projectId: string) => `/api/projects/export/${projectId}/quote-preview`,
    adminQuotePreview: (projectId: string) => `/api/admin/projects/export/${projectId}/quote-preview`,
    specialPricing: (projectId: string) => `/api/projects/${projectId}/special_pricing`,
    adminSpecialPricing: (projectId: string) => `/api/admin/projects/${projectId}/special_pricing`,
    exportPdf: (projectId: string) => `/api/projects/export/${projectId}/pdf`,
    adminExportPdf: (projectId: string) => `/api/admin/projects/export/${projectId}/pdf`,
    exportResellerPdf: (projectId: string) => `/api/projects/export/${projectId}/reseller-pdf`,
    adminExportResellerPdf: (projectId: string) => `/api/admin/projects/export/${projectId}/reseller-pdf`,
    exportDatasheets: (projectId: string) => `/api/projects/export/${projectId}/datasheets`,
    adminExportDatasheets: (projectId: string) => `/api/admin/projects/export/${projectId}/datasheets`,
    partsOptions: (projectId: string) => `/api/projects/${projectId}/parts/options`,
    adminPartsOptions: (projectId: string) => `/api/admin/projects/${projectId}/parts/options`,
    parts: (projectId: string) => `/api/projects/${projectId}/parts`,
    adminParts: (projectId: string) => `/api/admin/projects/${projectId}/parts`,
    activityQuotes: (projectId: string) => `/api/projects/${projectId}/activity/quotes`,
    adminActivityQuotes: (projectId: string) => `/api/admin/projects/${projectId}/activity/quotes`,
    activityQuotePdf: (projectId: string, quoteNumber: string) => `/api/projects/${projectId}/activity/quotes/${quoteNumber}/pdf`,
    adminActivityQuotePdf: (projectId: string, quoteNumber: string) => `/api/admin/projects/${projectId}/activity/quotes/${quoteNumber}/pdf`,
    messages: (projectId: string) => `/api/projects/${projectId}/messages`,
    adminMessages: (projectId: string) => `/api/admin/projects/${projectId}/messages`,
    messagesRead: (projectId: string) => `/api/projects/${projectId}/messages/read`,
    adminMessagesRead: (projectId: string) => `/api/admin/projects/${projectId}/messages/read`,
  },

  partNumbers: {
    adminList: '/api/admin/part_numbers',
    adminExport: '/api/admin/part_numbers/export',
    adminPriceListPdf: '/api/admin/part_numbers/export/pdf',
    adminOne: (id: string) => `/api/admin/part_numbers/${id}`,
    adminDatasheet: (id: string) => `/api/admin/part_numbers/${id}/datasheet`,
  },

  installationPricing: {
    adminList: '/api/admin/installation_pricing',
  },

  manufacturers: {
    adminList: '/api/admin/manufacturers',
    adminExport: '/api/admin/manufacturers/export',
    adminOne: (manufacturerId: string) => `/api/admin/manufacturers/${manufacturerId}`,
    suggest: '/api/manufacturers/suggest',
  },

  cabinetManufacturers: {
    list: '/api/cabinet_manufacturers',
    adminList: '/api/admin/cabinet_manufacturers',
    adminOne: (cabinetManufacturerId: string) => `/api/admin/cabinet_manufacturers/${cabinetManufacturerId}`,
    suggest: '/api/cabinet_manufacturers/suggest',
  },

  resellers: {
    adminList: '/api/admin/resellers',
    adminExport: '/api/admin/resellers/export',
    adminOne: (resellerId: string) => `/api/admin/resellers/${resellerId}`,
    adminLogoIntent: (resellerId: string) => `/api/admin/resellers/${resellerId}/logo/upload-intent`,
    adminLogoComplete: (resellerId: string) => `/api/admin/resellers/${resellerId}/logo/complete`,
    adminLogoPreview: (resellerId: string) => `/api/admin/resellers/${resellerId}/logo`,
  },

  myOrganization: {
    root: '/api/my_organization',
    logoIntent: '/api/my_organization/logo/upload-intent',
    logoComplete: '/api/my_organization/logo/complete',
    logoPreview: '/api/my_organization/logo',
    logo: '/api/my_organization/logo',
  },

  customerProfiles: {
    list: '/api/customer_profiles',
    adminList: '/api/admin/customer_profiles',
    one: (profileId: string) => `/api/customer_profiles/${profileId}`,
    adminOne: (profileId: string) => `/api/admin/customer_profiles/${profileId}`,
    adminDecision: (profileId: string) => `/api/admin/customer_profiles/${profileId}/decision`,
    adminPricing: (profileId: string) => `/api/admin/customer_profiles/${profileId}/pricing`,
    compliance: (profileId: string) => `/api/customer_profiles/${profileId}/compliance`,
    adminCompliance: (profileId: string) => `/api/admin/customer_profiles/${profileId}/compliance`,
    activities: (profileId: string) => `/api/customer_profiles/${profileId}/activities`,
    adminActivities: (profileId: string) => `/api/admin/customer_profiles/${profileId}/activities`,
    activity: (profileId: string, activityId: string) => `/api/customer_profiles/${profileId}/activities/${activityId}`,
    adminActivity: (profileId: string, activityId: string) => `/api/admin/customer_profiles/${profileId}/activities/${activityId}`,
    statusUpdates: (profileId: string) => `/api/customer_profiles/${profileId}/status-updates`,
    adminStatusUpdates: (profileId: string) => `/api/admin/customer_profiles/${profileId}/status-updates`,
    renewals: (profileId: string) => `/api/customer_profiles/${profileId}/renewals`,
    adminRenewals: (profileId: string) => `/api/admin/customer_profiles/${profileId}/renewals`,
    adminRenewalDecision: (profileId: string, renewalId: string) => `/api/admin/customer_profiles/${profileId}/renewals/${renewalId}/decision`,
  },

  workOrders: {
    list: '/api/work_orders',
    adminList: '/api/admin/work_orders',
    one: (workOrderId: string) => `/api/work_orders/${workOrderId}`,
    adminOne: (workOrderId: string) => `/api/admin/work_orders/${workOrderId}`,
    adminStatus: (workOrderId: string) => `/api/admin/work_orders/${workOrderId}/status`,
    adminAssign: (workOrderId: string) => `/api/admin/work_orders/${workOrderId}/assign`,
    adminForProject: (projectId: string) => `/api/admin/projects/${projectId}/work_orders`,
  },

  serviceReports: {
    forWorkOrder: (workOrderId: string) => `/api/work_orders/${workOrderId}/service_reports`,
    adminForWorkOrder: (workOrderId: string) => `/api/admin/work_orders/${workOrderId}/service_reports`,
    one: (reportId: string) => `/api/service_reports/${reportId}`,
    adminOne: (reportId: string) => `/api/admin/service_reports/${reportId}`,
    adminReview: (reportId: string) => `/api/admin/service_reports/${reportId}/review`,
  },

  files: {
    uploadIntent: '/api/files/upload_intents',
    complete: '/api/files/complete',
    forProject: (projectId: string) => `/api/admin/projects/${projectId}/files`,
    forWorkOrder: (workOrderId: string) => `/api/work_orders/${workOrderId}/files`,
  },

  batteries: {
    list: '/api/batteries',
    adminList: '/api/admin/batteries',
    export: '/api/batteries/export',
    adminExport: '/api/admin/batteries/export',
    one: (batteryId: string) => `/api/batteries/${batteryId}`,
    adminOne: (batteryId: string) => `/api/admin/batteries/${batteryId}`,
    adminDelete: (batteryId: string) => `/api/admin/batteries/${batteryId}`,
    archiveOne: (batteryId: string) => `/api/batteries/${batteryId}/archived`,
    adminArchiveOne: (batteryId: string) => `/api/admin/batteries/${batteryId}/archived`,
    bulkArchive: '/api/batteries/archived',
    adminBulkArchive: '/api/admin/batteries/archived',
    suggest: '/api/batteries/suggest',
  },

  batteryCabinetModels: {
    list: '/api/battery_cabinet_models',
    adminList: '/api/admin/battery_cabinet_models',
    one: (batteryCabinetModelId: string) => `/api/battery_cabinet_models/${batteryCabinetModelId}`,
    adminOne: (batteryCabinetModelId: string) => `/api/admin/battery_cabinet_models/${batteryCabinetModelId}`,
    adminDelete: (batteryCabinetModelId: string) => `/api/admin/battery_cabinet_models/${batteryCabinetModelId}`,
    adminArchiveOne: (batteryCabinetModelId: string) => `/api/admin/battery_cabinet_models/${batteryCabinetModelId}/archived`,
    adminBulkArchive: '/api/admin/battery_cabinet_models/archived',
  },

  cables: {
    adminList: '/api/admin/cables',
    adminOne: (cableId: string) => `/api/admin/cables/${cableId}`,
    adminBulkArchive: '/api/admin/cables/archived',
    adminArchiveOne: (cableId: string) => `/api/admin/cables/${cableId}/archived`,
  },

  flameArrestors: {
    list: '/api/flame_arrestors',
    adminList: '/api/admin/flame_arrestors',
    one: (flameArrestorId: string) => `/api/flame_arrestors/${flameArrestorId}`,
    adminOne: (flameArrestorId: string) => `/api/admin/flame_arrestors/${flameArrestorId}`,
    archiveOne: (flameArrestorId: string) => `/api/flame_arrestors/${flameArrestorId}/archived`,
    adminArchiveOne: (flameArrestorId: string) => `/api/admin/flame_arrestors/${flameArrestorId}/archived`,
    bulkArchive: '/api/flame_arrestors/archived',
    adminBulkArchive: '/api/admin/flame_arrestors/archived',
    suggest: '/api/flame_arrestors/suggest',
  },
} as const;
